import { render, staticRenderFns } from "./CreateOrCopy.vue?vue&type=template&id=27a07b44&scoped=true"
import script from "./CreateOrCopy.vue?vue&type=script&lang=js"
export * from "./CreateOrCopy.vue?vue&type=script&lang=js"
import style0 from "./CreateOrCopy.vue?vue&type=style&index=0&id=27a07b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a07b44",
  null
  
)

export default component.exports